import { ColorVariant, Gradient, colors, getRecipeColor } from '@ui-components/neo.tax';

const sliderColor = (variant?: ColorVariant): string => {
  if (!variant) {
    return colors.black;
  }
  return getRecipeColor(variant, 'whiteBg').text;
};

export const sliderBackground = ({ value, variant }: { value: number; variant?: ColorVariant }): Gradient => ({
  direction: 'to right',
  colors: [
    [sliderColor(variant), [0, value]],
    [colors.white, [value, 100]],
  ],
});
